// extracted by mini-css-extract-plugin
export default {"body":"modal-body_body__EwZah","body-content":"modal-body_body-content__Df9OQ","body-sidebar":"modal-body_body-sidebar__ayIh9"};